import { TEMP_IMG } from "../config.js";
import i18next from "../i18n";
import View from "./View";

class ResultsItemView extends View {
  _data;
  _footer = document.querySelector(".footer-body");
  _gridSearch = document.querySelector(".grid-search");
  _header = document.querySelector(".header-offline-section");
  _navigation = document.querySelector(".navigation-list");
  _opening = document.querySelector(".section-header-opening");
  _products = document.querySelector(".parent-container-category");
  _SearchItem = document.querySelector(".search-results");
  _searchResultText = document.querySelector(".search-result-text");

  _spinner = document.querySelector(".loading-spinner-wrapper");

  _clearNav() {
    this._navigation.innerHTML = "";
  }

  // Clear the content of the elements

  _clearNoResults() {
    this._SearchItem.querySelector(".search-no-results")?.remove();
  }

  _clearProducts() {
    this._products.innerHTML = "";
  }

  _clearResults() {
    this._gridSearch.innerHTML = "";
    this._clearNoResults();
  }

  _clearResultText() {
    this._searchResultText.innerHTML = "";
  }

  _clearSpinner() {
    this._spinner.innerHTML = "";
  }

  _generateMarkupPreview(result) {
    return `
        <div  class="item-image-block">
          <img data-src="${result.imageUrl}" src=${TEMP_IMG} data-id=${
            result.idProduct
          } alt="" class="image-item">
          <div class="footer-item">
            <p class="item-name">${result.name}</p>
            <div class="menu-product-price">
              <p class="item-price">${this.formatCurrency(result.price)}</p>
            </div>
          </div>
        </div>
    `;
  }

  _generateMarkupResults() {
    return this._data.map(this._generateMarkupPreview.bind(this)).join("");
  }

  _generateTextResults() {
    const SINGLE_RESULT_COUNT = 1;

    // Get name of searched product
    const parsedUrl = new URL(window.location.href);
    const query = parsedUrl.searchParams.get("search");

    const resultCount = this._data.length;
    const resultText =
      resultCount === SINGLE_RESULT_COUNT
        ? i18next.t("search.result")
        : i18next.t("search.result_plural");

    return `<p>${resultCount} ${resultText} ${i18next.t("prepositions.for")} '${query}'</p>`;
  }

  // Product data is located in this._data
  renderData(data) {
    const NO_RESULTS = 0;

    // Display elements
    this._header.style.display = "block";
    this._opening.style.display = "block";
    this._footer.style.display = "flex";
    this._SearchItem.style.display = "block";

    // Remove spinner
    this._clearSpinner();

    // Hide elements
    this._spinner.style.display = "none";

    // Hide search modal
    this._overlaySearch.style.display = "none";

    // Show scroll bar
    document.body.style.overflow = "visible";

    if (!data || (Array.isArray(data) && data.length === NO_RESULTS)) {
      return this.renderNoResults();
    }

    this._data = data;
    const markupResults = this._generateMarkupResults();
    const markupTextResults = this._generateTextResults();

    // Parse the specified text as HTML and inserts the resulting nodes into the DOM tree at a specified position.
    this._gridSearch.insertAdjacentHTML("afterbegin", markupResults);
    this._searchResultText.insertAdjacentHTML("afterbegin", markupTextResults);

    // Watch target element whenever the target meets the threshold
    document
      .querySelectorAll(".w-layout-grid.grid-search img[data-src]")
      .forEach((img) => {
        if (img.dataset.src !== "") {
          this._imgObserver.observe(img);
        }
      });

    return true;
  }

  renderError(message = i18next.t("error.resultItemInfo")) {
    this._clearModalError();
    this._errorContainer.textContent = message;
    this.openModalError();
  }

  renderNoResults() {
    // Get name of searched product
    const parsedUrl = new URL(window.location.href);
    const query = parsedUrl.searchParams.get("search");

    const markup = `
    <div class="error search-no-results">
        <p>${i18next.t("error.notFound")} '${query}'</p>
    </div>`;

    this._clearNoResults();
    this._gridSearch.insertAdjacentHTML("beforebegin", markup);
  }

  renderSpinner() {
    const markup = `
      <div class="loading-spinner">
      </div>
    `;

    // Hide elements
    this._header.style.display = "none";
    this._opening.style.display = "none";
    this._footer.style.display = "none";
    this._products.style.display = "none";

    // Clear previous results due to images taking up a lot of space
    this._clearResults();
    // Clear scrollable navbar to avoid unexpected effects (It will not be used, hence cleared)
    this._clearNav();
    // Clear previous products due to images taking up a lot of space
    this._clearProducts();
    // Clear previous result texts
    this._clearResultText();

    // Display element
    this._spinner.style.display = "flex";

    this._spinner.insertAdjacentHTML("afterbegin", markup);
  }
}

export default new ResultsItemView();
